import {useEffect,useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import './GalleryPage.css';

const {FiImage,FiMaximize2,FiX,FiChevronLeft,FiChevronRight}=FiIcons;

const galleryImages=[
  {
    src: 'https://media-manager-c.questera.ai/greta-media/84bd1a1ec4b169d3b45fb6d9222544ea571861834b2a41df59b8dd4fbd9877604e1a1a824c0c77323e9e6a3b81021929/images/aW1hZ2UvanBlZw==/87c33f092e1732df6df9bd9333be79b2.jpg',
    alt: 'A community speaker in a blue suit seated on a couch during an interview'
  },
  {
    src: 'https://media-manager-c.questera.ai/greta-media/84bd1a1ec4b169d3b45fb6d9222544ea571861834b2a41df59b8dd4fbd9877604e1a1a824c0c77323e9e6a3b81021929/images/aW1hZ2UvanBlZw==/2aca53dd83901b6ff4c7847c88093550.jpg',
    alt: 'A community speaker being filmed while seated on a yellow couch'
  },
  {
    src: 'https://media-manager-c.questera.ai/greta-media/84bd1a1ec4b169d3b45fb6d9222544ea571861834b2a41df59b8dd4fbd9877604e1a1a824c0c77323e9e6a3b81021929/images/aW1hZ2UvanBlZw==/5170dc8ec445b57027797a4a54914e03.jpg',
    alt: 'A close view of a community speaker sharing a message'
  },
  {
    src: 'https://media-manager-c.questera.ai/greta-media/84bd1a1ec4b169d3b45fb6d9222544ea571861834b2a41df59b8dd4fbd9877604e1a1a824c0c77323e9e6a3b81021929/images/aW1hZ2UvanBlZw==/7977fadd00142c9d5ee765d55df0aafc.jpg',
    alt: 'A community speaker seated on a green couch during an interview'
  },
  {
    src: 'https://img.flexifunnels.com/images/39533/IMG20260524WA0780_l9rhn_1920.jpg',
    alt: 'Members of the Bully Free community gathered at an event'
  },
  {
    src: 'https://media-manager-c.questera.ai/greta-media/84bd1a1ec4b169d3b45fb6d9222544ea571861834b2a41df59b8dd4fbd9877604e1a1a824c0c77323e9e6a3b81021929/images/aW1hZ2UvanBlZw==/c6e7fbf5f8727e8b488d268b184b08bb.jpg',
    alt: 'A community event with participants seated around a table'
  },
  {
    src: 'https://media-manager-c.questera.ai/greta-media/84bd1a1ec4b169d3b45fb6d9222544ea571861834b2a41df59b8dd4fbd9877604e1a1a824c0c77323e9e6a3b81021929/images/aW1hZ2UvanBlZw==/3c86e2b0fec89b8e95c76355e52357bc.jpg',
    alt: 'A speaker talking with a young participant at a community gathering'
  },
  {
    src: 'https://media-manager-c.questera.ai/greta-media/84bd1a1ec4b169d3b45fb6d9222544ea571861834b2a41df59b8dd4fbd9877604e1a1a824c0c77323e9e6a3b81021929/images/aW1hZ2UvanBlZw==/f2fd56146e52a378ba4f3152be018786.jpg',
    alt: 'A speaker and youth participant sharing a moment at an event'
  },
  {
    src: 'https://media-manager-c.questera.ai/greta-media/84bd1a1ec4b169d3b45fb6d9222544ea571861834b2a41df59b8dd4fbd9877604e1a1a824c0c77323e9e6a3b81021929/images/aW1hZ2UvanBlZw==/465256b5d5778e6bdd66a33ea72f0e4d.jpg',
    alt: 'A youth participant speaking with a community mentor'
  },
  {
    src: 'https://media-manager-c.questera.ai/greta-media/84bd1a1ec4b169d3b45fb6d9222544ea571861834b2a41df59b8dd4fbd9877604e1a1a824c0c77323e9e6a3b81021929/images/aW1hZ2UvanBlZw==/ddfd303e0c1cf2d37073215431bedfb7.jpg',
    alt: 'A young participant speaking with a mentor at the community event'
  }
];

function GalleryPage() {
  const [selectedIndex,setSelectedIndex]=useState(null);
  const selectedImage=selectedIndex===null ? null : galleryImages[selectedIndex];
  const navigateImage=(direction)=> setSelectedIndex((current)=> (current + direction + galleryImages.length) % galleryImages.length);

  useEffect(()=> {
    if (selectedIndex===null) return undefined;
    const handleKeyDown=(event)=> {
      if (event.key==='Escape') setSelectedIndex(null);
      if (event.key==='ArrowLeft') navigateImage(-1);
      if (event.key==='ArrowRight') navigateImage(1);
    };
    window.addEventListener('keydown',handleKeyDown);
    return ()=> window.removeEventListener('keydown',handleKeyDown);
  },[selectedIndex]);

  return (
    <section className="gallery-page">
      <div className="page-intro">
        <span className="eyebrow"><SafeIcon icon={FiImage} /> Moments that matter</span>
        <h1>Photo gallery</h1>
        <p>A glimpse of our community coming together for a kinder,safer online world.</p>
      </div>
      <div className="gallery-grid">
        {galleryImages.map((image,index)=> (
          <button
            className="gallery-photo"
            type="button"
            key={image.src}
            onClick={()=> setSelectedIndex(index)}
            aria-label={`View photo ${index + 1} larger`}
          >
            <img src={image.src} alt={image.alt} />
            <span className="gallery-photo-action"><SafeIcon icon={FiMaximize2} /> View photo</span>
          </button>
        ))}
      </div>
      {selectedImage && (
        <div
          className="gallery-lightbox"
          role="presentation"
          onClick={(event)=> {
            if (event.target===event.currentTarget) setSelectedIndex(null);
          }}
        >
          <button className="gallery-close" type="button" onClick={()=> setSelectedIndex(null)} aria-label="Close photo">
            <SafeIcon icon={FiX} />
          </button>
          <button className="gallery-nav gallery-prev" type="button" onClick={()=> navigateImage(-1)} aria-label="Previous photo">
            <SafeIcon icon={FiChevronLeft} />
          </button>
          <img src={selectedImage.src} alt={selectedImage.alt} />
          <button className="gallery-nav gallery-next" type="button" onClick={()=> navigateImage(1)} aria-label="Next photo">
            <SafeIcon icon={FiChevronRight} />
          </button>
          <span className="gallery-counter">{selectedIndex + 1} / {galleryImages.length}</span>
        </div>
      )}
    </section>
  );
}

export default GalleryPage;